import React, { Component } from 'react';
import { Link } from 'react-router';

import InputText from '../../../form/input/text';
import InputSubmit from '../../../form/input/submit';
import {
	formIsValid,
	VALIDATE_EMAIL,
	VALIDATE_MIN_LENGTH,
} from '../../../form/validate';

import { accountRoute } from '../../../../routes';

import FBAuth from '../../../../utils/social/fb';
import GoogleAuth from '../../../../utils/social/google';
import TwitterAuth from '../../../../utils/social/twitter';

export default class ProfileNotSignedIn extends Component {

	constructor(props) {
		super();

		this.FB = new FBAuth();
		this.GGL = new GoogleAuth();
		this.TWT = new TwitterAuth();

		this.state = {
			waiting: false,
		};
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.menuActive) {
			setTimeout(() => {
				this.FB.load();
				this.GGL.load();
			}, 701);
		}
	}

	render() {
		return (
			<div className='profile-signup'>
				{this.props.showLogin && (
				<div className='hide-mobile'>
					<form onSubmit={(e) => { this.submitHandler(e); }} className='profile-signup' key='0'>
						<InputText
							ref='email'
							name='email'
							type='text'
							placeholder='Email'
							manualValidate={true}
							validate={[
								{rule: VALIDATE_EMAIL},
							]}
						/>

						<span></span>

						<InputText
							ref='password'
							name='password'
							type='password'
							placeholder='Password'
							manualValidate={true}
							validate={[
								{rule: VALIDATE_MIN_LENGTH, params: 6},
							]}
						/>

						<div>
							<InputSubmit name='Sign in' className='button--go' waiting={this.state.waiting} />
						</div>
					</form>

					<div>
						<Link to={accountRoute('/recover')} className='nav-profile__account-links' onClick={this.props.toggleMenu}>
							Forgot password
						</Link>

						<Link to={accountRoute('/register')} className='nav-profile__account-links' onClick={this.props.toggleMenu}>
							Sign up
						</Link>
					</div>

					<div className='nav-profile__social'>
						<div className='nav-profile__social__head'>Or use social sign in</div>
						<div>
							<button className='button button--fb' onClick={this.loginFB.bind(this)}>Facebook</button>
							<button className='button button--twt' onClick={this.loginTWT.bind(this)}>Twitter</button>
							<button className='button button--ggl' onClick={this.loginGGL.bind(this)}>Google</button>
						</div>
					</div>
				</div>
				) || (
				<div className="hide-mobile span13-mobile mainmenu__nav__bottom__desktop-signin">
					<button onClick={this.props.showLoginToggle} className='button button--go'>Sign in</button>
					<div>
						<Link to={accountRoute('/recover')} onClick={this.props.toggleMenu}>Forgot password</Link>
						<Link to={accountRoute('/register')} onClick={this.props.toggleMenu}>Sign Up</Link>
					</div>
				</div>
				)}
				<div className='hide-desktop hide-tablet span13-mobile mainmenu__nav__bottom__mobile-signin'>
					<Link to={accountRoute('/login')} onClick={this.props.toggleMenu} className='button button--go'>Sign in</Link>

					<div>
						<Link to={accountRoute('/recover')} onClick={this.props.toggleMenu}>Forgot password</Link>
					</div>
				</div>
			</div>
		);
	}

	submitHandler(e) {
		e.preventDefault();

		if (formIsValid([this.refs.email, this.refs.password])) {
			this.setState({...this.state, waiting: true});

			this.props.login(this.refs.email.value(), this.refs.password.value(), 1, () => {
				// component will have unmounted when this code is reached... so don't use state/props
				//Remove closing menu

			}, () => {
				this.setState({...this.state, waiting: false});
			});
		}

		return false;
	}

	loginFB() {
		this.FB.login(this.props.dispatch);
	}

	loginGGL() {
		this.GGL.login(this.props.dispatch);
	}

	loginTWT() {
		this.TWT.login(this.props.dispatch);
	}
}



/** WEBPACK FOOTER **
 ** ./frontend/components/globalNav/menu/profile/profileNotSignedIn.js
 **/